export default {
  BASE_URL: '/cb/payment/receive/register',
  api: [
    {
      name: 'receiveList',
      desc: '收款登记列表',
      method: 'GET',
      path: '/list'
    },
    {
      name: 'add',
      desc: '收款登记',
      method: 'POST',
      path: '/add'
    },
    {
      name: 'saleOrderList',
      desc: '销售订单列表',
      method: 'GET',
      path: '/order/list'
    },
    {
      name: 'importOrder',
      desc: '导入销售订单',
      method: 'POST',
      path: '/order/import'
    },
    {
      name: 'importOrderTemplate',
      desc: '销售订单模板',
      method: 'GET',
      path: '/order/import/tempInstall'
    },
    {
      name: 'submit',
      desc: '绑定提交',
      method: 'POST',
      path: '/bind'
    },
    {   
      name: 'unbind',
      desc: '解绑',
      method: 'POST',
      path: '/bind/cancel'
    },
    {   
      name: 'changeBind',
      desc: '换绑',
      method: 'POST',
      path: '/bind/change'
    },
    {
      name: 'detail',
      desc: '详情',
      method: 'GET',
      path: '/detail'
    },
    {
      name: 'delete',
      desc: '删除',
      method: 'POST',
      path: '/del'
    },
    {
      name: 'importReceipt',
      desc: '导入登记',
      method: 'POST',
      path: '/import'
    },
    {
      name: 'importReceiptTemplate',
      desc: '导入登记模板',
      method: 'GET',
      path: '/import/tempInstall'
    },
    {
      name: 'log',
      desc: '操作记录',
      method: 'GET',
      path: '/log/list'
    },
    {
      name: 'status',
      desc: '状态',
      method: 'GET',
      path: '/enum/billStatus'
    },
    {
      name: 'bindOrderRecords',
      desc: '销售订单绑定记录',
      method: 'GET',
      path: '/bind/order/list'
    },
    {
      name: 'bindProjRecords',
      desc: '项目绑定记录',
      method: 'GET',
      path: '/bind/project/list'
    },
    {
      name: 'bindCancelRecords',
      desc: '付款退款绑定记录',
      method: 'GET',
      path: '/bind/return/list'
    },
    {
      name: 'log',
      desc: '操作记录',
      method: 'GET',
      path: '/log/lis'
    },
    {
      name: 'bindOrder',
      desc: '项目绑定销售订单',
      method: 'POST',
      path: '/bind/project/toOrder'
    },
    {
      name: 'push',
      desc: '推送金蝶',
      method: 'POST',
      path: '/push/kinDee'
    }
  ]
}


// WEBPACK FOOTER //
// ./src/api/apis/self/statement/receive.js